// extracted by mini-css-extract-plugin
export var fullTwoColumns = "style-mod--full-two-columns--e91fc";
export var fullTwoColumnsImg = "style-mod--full-two-columns-img--8ab1c";
export var fullTwoColumnsItems = "style-mod--full-two-columns-items--98809";
export var fullTwoColumnsText = "style-mod--full-two-columns-text--c3dea";